import { useaxios } from "../../../utils/useaxios";
export default (from, to, expense_type_id_read) => recaller => setrecaller => initDispatch => clear => {
    console.log(expense_type_id_read);
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('expense/read.php', { from, to, expense_type_id_read }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            initDispatch({ type: 'setexpense', payload: res.data });
        }
        // setloading(false);
    });
}